class invRelatedBillCtrl {
    constructor($scope, logger, httpRequest, $state) {
        const _waitId = $state.params.waitId
        // 发票种类
        httpRequest.get_dictByTypeArr(['tax_includ', 'inv_type']).then((res) => {
            $scope.dictData = res.data.value
            $scope.invTypeList = $scope.dictData.inv_type
        })
        const queryOvatBillList = function () {
            const req = {

                pageNum: $scope.currentPage,
                pageSize: $scope.maxSize,
                param: _waitId,

            }
            httpRequest.post_getOvatInvoiceWaitBillList(req).then((res) => {
                $scope.resData = res.data.value.list
                $scope.totalItems = res.data.value.total
                $scope.currentPage = ++res.data.value.prePage
                $scope.maxSize = res.data.value.pageSize
            })
        }
        // 分页
        $scope.totalItems = 0 // 组件初始化设置总页数
        $scope.currentPage = 1 // 设置显示第一页
        $scope.maxSize = 10 // 每一叶显示记录数
        // 页面跳转
        $scope.pageChanged = function () {
            queryOvatBillList()
        }
        queryOvatBillList()
        // 销售单明细
        $scope.toCheckPage = function (item) {
            let url
            if (item.billId === undefined || item.billId === null) {
                logger.logError('参数错误，请刷新重试')
                return
            } if ($state.current.name === 'outputManage.FOManage.invoice.relatedBill') {
                url = $state.href('outputManage.FOManage.invoice.checkBillDetail', { billId: item.billId }, { reload: true })
            } else if ($state.current.name === 'outputManage.FOManage.eleInvoice.relatedBill') {
                url = $state.href('outputManage.FOManage.eleInvoice.checkBillDetail', { billId: item.billId }, { reload: true })
            } else if ($state.current.name === 'outputManage.FOManage.rollTypeInvoice.relatedBill') {
                url = $state.href('outputManage.FOManage.rollTypeInvoice.checkBillDetail', { billId: item.billId }, { reload: true })
            } else if ($state.current.name === 'outputManage.FOManage.vehicleInvoice.relatedBill') {
                url = $state.href('outputManage.FOManage.vehicleInvoice.checkBillDetail', { billId: item.billId }, { reload: true })
            }
            window.open(url, '_blank')
        }
        /**
         * 表相关的控制方法
         * 后期抽离成组件
         * 全选 / 排序 / 分页 / 选中行
         */

        // 表格固有方法功能 -未来抽象为datagrid 组件
        // $scope.rows = $scope.resData;
        // 全选状态
        $scope.tb_isAllselected = false
        // 表格行点击方法
        $scope.tb_rowClcik = function (...arg) {
            $scope.tb_rowSelect(...arg)
        }
        // 表格行checkSelect 方法
        $scope.tb_rowSelect = function (idx, row) {
            // 全选
            let len = 0
            for (const a in $scope.resData) {
                if ($scope.resData[a].selected == true) len++
            }
            if (len == $scope.resData.length) {
                $scope.tb_isAllselected = true
            } else {
                $scope.tb_isAllselected = false
            }
        }
        // 表格行划过
        $scope.tb_rowhover = function (row, flag) {
            row.mouseenter = flag
        }
        // 按钮滑过
        $scope.dropdown_rowhover = function (row, flag) {
            row.dropdownhover = flag
        }

        // 状态按钮滑过
        $scope.dropdown_rowhover_state = function (row, flag) {
            row.dropdowstatenhover = flag
        }
        // 表格全选
        $scope.tb_selectAll = function (val) {
            $scope.tb_isAllselected = val
            for (const a in $scope.resData) {
                $scope.resData[a].selected = $scope.tb_isAllselected
            }
        }
    }
}
invRelatedBillCtrl.$inject = ['$scope', 'logger', 'httpRequest', '$state']
export default invRelatedBillCtrl



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/invoice1/invRelatedBillCtrl.js